module.exports = __webpack_public_path__ + "img/fourday_ps_03.5a6f603e.jpg";